// auth.guard.ts

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  isjwtToken: any;
  constructor(private router: Router, private encryptDecryptService: EncryptDecryptService) { }

  canActivate(): boolean {
    const encryptedData = sessionStorage.getItem('u.');

    if (encryptedData !== null) {
      const decryptedData = this.encryptDecryptService.decryptUsingAES256(encryptedData);
      let userDetails = JSON.parse(decryptedData);
      const isjwtToken = userDetails.token;

      if (isjwtToken) {
        // If the user is already authenticated and has a valid JWT token,
        // redirect them to a home or dashboard page (where the authenticated user should land).
        this.router.navigateByUrl('/patient/invoices'); 
        return false;
      }
    }

    // If no JWT token is found, allow the user to access the login page
    return true;
  }
}
